export default __webpack_public_path__ + "static/media/skillbeta_logo.3002453f.gif";